import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export class ProfileNavigationMixin extends Vue {
  @State((state) => state.profile.me) me: any;

  goToProfile(profile: any): void {
    if (!profile || !profile.id) return;

    const isOwnProfile = profile.id === this.me?.id;
    const role = isOwnProfile ? this.me?.role : profile.role;

    const route =
      role === "FOUR_NETWORK"
        ? "timelineFourNetworkSection"
        : isOwnProfile
        ? "profileHome"
        : role === "MARKETING"
        ? "profileMarketing"
        : "profileCLevel";

    const params: Record<string, string> =
      role === "FOUR_NETWORK"
        ? { id: "2" }
        : isOwnProfile
        ? {}
        : { id: String(profile.id) };

    this.$router.push({ name: route, params });
  }
}
